import { ProductParagraph } from '@issuu/silkscreen';
import React, { useContext } from 'react';

import DocumentContext from '../DocumentPage/DocumentContext';
import { GoogleAdsTemplate } from './GoogleAdsTemplate';

export type Props = {
    index: number;
};

export const AdsStoriesInside: React.FC<Props> = ({ index }) => {
    const {
        publisher: {
            licenses: { docpageAds },
        },
    } = useContext(DocumentContext);
    const network = docpageAds
        ? '/30443627/DocPage_DocInfo_adConnect'
        : '/30443627/DocPage_Sections';

    return (
        <div>
            <GoogleAdsTemplate
                adSizes={[
                    [400, 300],
                    [300, 250],
                ]}
                idSuffix={`storiesInside_${index}`}
                network={network}
            />
            <ProductParagraph step="negative-2">Advertisement</ProductParagraph>
        </div>
    );
};
